// inv/src/seo/breadcrumbs.jsx
import { Link, useLocation } from 'react-router-dom';
import languages from '../locales/languages.js';

export default function Breadcrumbs({ mapSegments = {}, pageTitle }) {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const languageCodes = languages.map(lang => lang.code);

  let prefix = '';
  let startIndex = 0;
  if (segments.length && languageCodes.includes(segments[0])) {
    prefix = `/${segments[0]}`;
    startIndex = 1;
  }

  const pathSegments = segments.slice(startIndex);

  const itemsForLd = [];

  itemsForLd.push({
    "@type": "ListItem",
    position: 1,
    name: 'Home',
    item: `${prefix || ''}/`
  });

  const crumbs = pathSegments.map((seg, idx) => {
    const isLast = idx === pathSegments.length - 1;
    const urlPath = `${prefix}/${pathSegments.slice(0, idx + 1).join('/')}`;
    const label = isLast && pageTitle ? pageTitle : mapSegments[seg] || seg;

    itemsForLd.push({
      "@type": "ListItem",
      position: idx + 2,
      name: label,
      item: isLast ? undefined : urlPath
    });

    return (
      <span key={idx} className="mx-1">
        <span className="text-gray-400">/</span>{' '}
        {isLast
          ? <span className="font-semibold">{label}</span>
          : <Link to={urlPath} className="hover:underline">{label}</Link>
        }
      </span>
    );
  });

  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemsForLd
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
      />

      <nav aria-label="breadcrumb" className="text-base text-gray-600  mb-4 flex flex-wrap items-center">
        <Link to={prefix || '/'} className="hover:underline">Home</Link>
        {crumbs}
      </nav>
    </>
  );
}
